import { Inject, Injectable } from '@angular/core';
import Env from '../../env';

@Injectable({
    providedIn: 'root'
})
export class AllowedPathService {
    allowedPaths: string[] = [];

    constructor(@Inject('ENV') public env: Env) {
        this.allowedPaths = this.env?.ALLOWED_PATHS;
    }

    isLoginOrRegistrationAllowed(): boolean {
        return this.allowedPaths.includes('/login') || this.allowedPaths.includes('/register');
    }

    isWebPurchaseAllowed(): boolean {
        return (
            this.allowedPaths.includes('/purchase/ticket') ||
            this.allowedPaths.includes('/purchase/wallet') ||
            this.allowedPaths.includes('/purchase-v2')
        );
    }
}
